export const safeLockEndpoints = (builder) => ({
    getSafeLocks: builder.query({
        query: _ => ({url: `/safe-lock`, method: 'get'}),
        providesTags: ['Safe Locks'],
    }), 
    downloadSafeLockReport: builder.mutation({
        query: ({ startDate, endDate, status, format }) => ({
            url: `/safe-lock/report/${format}?startDate=${startDate || ""}`
                + `&endDate=${endDate || ""}`
                + `&status=${status || ""}`,
            method: 'post'
        }),
    }),
    downloadLiquidationReport: builder.mutation({
        query: ({ startDate, endDate, status, format }) => ({
            url: `/safe-lock/liquidation/report/${format}?startDate=${startDate || ""}`
                + `&endDate=${endDate || ""}`
                + `&status=${status || ""}`,
            method: 'post'
        }),
    }),
    
    getSafeLockPlans: builder.query({
        query: _ => ({url: `/safe-lock/plans`, method: 'get'}),
        providesTags: ['Safe Locks'],
    }), 
    getDisabledPlans: builder.query({
        query: _ => ({url: `/safe-lock/plans?IsDisabled=true`, method: 'get'}),
        providesTags: ['Safe Locks'],
    }), 
    createPlan: builder.mutation({
        query: (data) => ({url: `/safe-lock`, method: 'post', body: data}),
        invalidatesTags: ['Safe Locks'],
    }),
    updatePlan: builder.mutation({
        query: ({planId, ...data}) => ({url: `/safe-lock/${planId}`, method: 'patch', body: { ...data } }),
        invalidatesTags: ['Safe Locks'],
    }),
    enablePlan: builder.mutation({
        query: ({planId}) => ({url: `/safe-lock/enable/${planId}`, method: 'patch'}),
        invalidatesTags: ['Safe Locks'],
    }),
    disablePlan: builder.mutation({
        query: ({planId}) => ({url: `/safe-lock/disable/${planId}`, method: 'patch'}),
        invalidatesTags: ['Safe Locks'],
    }),
    updateSafeLockStatus: builder.mutation({
        query: ({ transactionRef }) => ({
            url: `/safe-lock/update-status`,
            method: 'post',
            body: { transactionRef }
        }),
        invalidatesTags: ['Safe Locks'],
    }),

    
})